<template>
  <FadeTransition duration="150">
    <div v-show="showLoader" class="modal-backdrop">
      <CircularLoader />
    </div>
  </FadeTransition>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CircularLoader from "@/components/shared/loaders/CircularLoader";
import FadeTransition from "@/components/shared/transitions/FadeTransition";

export default {
  components: {
    CircularLoader,
    FadeTransition,
  },
  computed: {
    ...mapGetters("system", { showLoader: "getLoaderStatus" }),
  },
  methods: {
    ...mapActions("system", ["setLoaderStatus"]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.modal-backdrop {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100000;

  width: 100vw;
  height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(26, 26, 26, 0.1);
  backdrop-filter: blur(2px);
}
</style>
